import React from 'react';
import { Modal } from 'react-bootstrap';
import { ReactPhotoSphereViewer } from 'react-photo-sphere-viewer';

function PanoramaModal({ show, onHide, selectedPanorama }) {
  return (
    <Modal 
      show={show} 
      onHide={onHide}
      size="xl"
      centered
      fullscreen={true}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>360° Panorama View</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0" style={{ height: 'calc(100vh - 60px)' }}>
        {selectedPanorama && (
          <ReactPhotoSphereViewer
            src={`photos/${selectedPanorama}`}
            height="100%"
            width="100%"
            options={{
              navbar: ['autorotate', 'zoom', 'download', 'fullscreen'],
              useXmpData: true,
              fisheye: false,
              mousewheel: true,
              mousemove: true,
              keyboard: 'fullscreen',
              defaultZoomLvl: 50,
              minFov: 30,
              maxFov: 90,
              defaultLat: 0,
              defaultLong: 0,
              touchmoveTwoFingers: false,
              mousewheelCtrlKey: false
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default PanoramaModal;